import React, { useEffect } from "react";
import { useRef, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import API_BASE_URL from "../../config";
import { authFetch } from "../../utility/authFetch";

function FollowUpReg({ setLoader, setSearch, search, id }) {
  const formRef = useRef();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [name, setName] = useState("");
  const [gender, setGender] = useState("");
  const [age, setAge] = useState("");
  const [contact, setContact] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [problemQuery, setProblemQuery] = useState("");
  const [ProblemList, setProblemList] = useState([]);
  const [doctorQuery, setDoctorQuery] = useState("");
  const [doctorList, setDoctorList] = useState([]);
  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("Cash");
  const today = new Date().toISOString().split("T")[0];
  const [appointmentDate, setAppointmentDate] = useState(today);
  const [totalAppointments, setTotalAppointments] = useState(0);

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/patient-details-follow-up-reg?id=${id}`
        );
        const result = await response.json();
        const patientDetails = result.patient;
        setName(patientDetails[1]);
        setGender(patientDetails[2]);
        setAge(patientDetails[3]);
        setContact(patientDetails[4]);
        setAddress(patientDetails[5]);
        setEmail(patientDetails[6]);
        setDoctorQuery(patientDetails[14]);
        setProblemQuery(patientDetails[15]);
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    };

    fetchPatient();
  }, [search, id]);

  useEffect(() => {
    if (!appointmentDate || !doctorList || !doctorQuery) {
      return;
    }

    const fetchPatient = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/get-total-appointment?date=${appointmentDate}&doctor=${doctorQuery}`
        );
        const result = await response.json();
        setTotalAppointments(result.total_appointments);
      } catch (error) {
        console.error("Error fetching patient:", error);
      }
    };

    fetchPatient();
  }, [doctorQuery, appointmentDate]);

  useEffect(() => {
    if (!doctorQuery || !doctorList.includes(doctorQuery)) {
      setAmount("");
      return;
    }

    const fetchAmount = async () => {
      try {
        const response = await authFetch(
          `${API_BASE_URL}/api/patient-details-follow-up-fees?doctor=${doctorQuery}&id=${id}`
        );
        const result = await response.json();
        setAmount(Number(result.amount));

        if (amount === 0) {
          setPaymentMode("N/A");
        }
      } catch (error) {
        console.error("Error fetching amount:", error);
      }
    };

    fetchAmount();
  }, [doctorQuery, doctorList]);

  useEffect(() => {
    if (!problemQuery) {
      setProblemList([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      authFetch(`${API_BASE_URL}/api/problem-options?query=${problemQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setProblemList(data.problems.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [problemQuery]);

  useEffect(() => {
    if (!doctorQuery) {
      setProblemList([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      authFetch(`${API_BASE_URL}/api/doctor-options?query=${doctorQuery}`)
        .then((res) => res.json())
        .then((data) => {
          setDoctorList(data.doctors.map((d) => d.name));
        })
        .catch((err) => console.error("Error fetching:", err));
    }, 400);

    return () => clearTimeout(delayDebounce);
  }, [doctorQuery]);

  const handleSubmit = async (e) => {
    setLoader(true);
    e.preventDefault();
    setIsSubmitting(true);

    if (!formRef.current.checkValidity()) {
      formRef.current.reportValidity();
      setIsSubmitting(false);
      setLoader(false);
      return;
    }

    const formData = new FormData(formRef.current);
    const url = `${API_BASE_URL}/api/registration`;

    formData.append("type", "follow-up");
    formData.append("id", id);

    const method = "POST";

    try {
      const response = await authFetch(url, {
        method,
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        alert("Follow Up registered successfully");
        formRef.current.reset();
        setIsSubmitting(false);
        setLoader(false);
        setProblemQuery("");
        setProblemList([]);
        setDoctorList([]);
        setDoctorQuery("");
        setSearch(true);
      } else {
        alert(result.error || "Error uploading data");
        setIsSubmitting(false);
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
      alert("Server error");
      setIsSubmitting(false);
      setLoader(false);
    }
  };

  return (
    <div className="p-4" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container bg-white p-4 rounded shadow-sm">
        <div className="d-flex flex-row justify-content-between">
          <h5 className="mb-3">Follow Up Registration</h5>
          <Button onClick={() => setSearch(true)} variant="warning">
            Go Back
          </Button>
        </div>
        <Form onSubmit={handleSubmit} ref={formRef}>
          <Row className="align-items-end g-3">
            <Col md={4}>
              <Form.Group className="mb-3" controlId="formDoctor">
                <Form.Label>
                  Doctor <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Select Doctor"
                  name="doctor"
                  required
                  autoComplete="off"
                  list="doctor-options"
                  value={doctorQuery}
                  onChange={(e) => setDoctorQuery(e.target.value)}
                />
                <datalist id="doctor-options">
                  {doctorList.map((option, index) => (
                    <option key={index} value={option} />
                  ))}
                </datalist>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formAmount">
                <Form.Label>Appointment Date</Form.Label>
                <Form.Control
                  type="date"
                  name="appointmentDate"
                  value={appointmentDate}
                  onChange={(e) => setAppointmentDate(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formTotalAppointments">
                <Form.Label>Total Appointments</Form.Label>
                <Form.Control
                  type="text"
                  name="totalAppointments"
                  value={totalAppointments}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formPatientName">
                <Form.Label>
                  Patient Name <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  required
                  value={name}
                  readOnly
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formGender">
                <Form.Label>
                  Gender <span className="text-danger">*</span>
                </Form.Label>
                <Form.Select
                  aria-label="Category"
                  name="gender"
                  required
                  value={gender}
                  readOnly
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formAge">
                <Form.Label>
                  Age <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control type="number" value={age} name="age" readOnly />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formContactNumber">
                <Form.Label>
                  Contact Number <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="tel"
                  value={contact}
                  name="contactNumber"
                  required
                  autoComplete="off"
                  onChange={(e) => setContact(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formAddress">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter address"
                  name="address"
                  autoComplete="off"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter Email"
                  name="email"
                  autoComplete="off"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formProblem">
                <Form.Label>
                  Problem <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Select Problem"
                  name="problem"
                  required
                  autoComplete="off"
                  list="problem-options"
                  value={problemQuery}
                  onChange={(e) => setProblemQuery(e.target.value)}
                />
                <datalist id="problem-options">
                  {ProblemList.map((option, index) => (
                    <option key={index} value={option} />
                  ))}
                </datalist>
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formAmount">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  placeholder="Choose Doctor"
                  name="fees"
                  value={amount}
                  readOnly={amount === 0}
                  onChange={(e) => setAmount(Number(e.target.value))}
                />
              </Form.Group>
            </Col>

            <Col md={4}>
              <Form.Group className="mb-3" controlId="formPaymentMode">
                <Form.Label>Payment Mode</Form.Label>
                <Form.Select
                  aria-label="Category"
                  name="paymentMode"
                  required
                  value={paymentMode}
                  onChange={(e) => setPaymentMode(e.target.value)}
                  readOnly={paymentMode === "N/A"}
                >
                  <option value="Cash">Cash</option>
                  <option value="Card">Card</option>
                  <option value="UPI">UPI</option>
                  <option value="N/A">N/A</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <Button variant="primary" type="submit" disabled={isSubmitting}>
            SUBMIT
          </Button>
        </Form>
      </div>
    </div>
  );
}

export default FollowUpReg;
